var map = {
	"./bomb/Classical.txt": "16c5",
	"./bomb/decades/1950s.txt": "c137",
	"./bomb/decades/1960s.txt": "89f5",
	"./bomb/decades/1970s.txt": "8d41",
	"./bomb/decades/1980s.txt": "cfac",
	"./bomb/decades/1990s.txt": "1ec2",
	"./bomb/decades/2000s.txt": "4386",
	"./bomb/decades/2010s.txt": "734c",
	"./bomb/movies_and_tv_shows.txt": "47ad",
	"./bomb/rock.txt": "edf9",
	"./bomb/youtube_most_viewed.txt": "9b69",
	"./draw/easy.txt": "558c",
	"./draw/hard.txt": "3b55",
	"./draw/medium.txt": "f134",
	"./show/easy.txt": "f138",
	"./show/hard.txt": "e6cc",
	"./show/medium.txt": "d70f",
	"./speak/easy.txt": "5105",
	"./speak/hard.txt": "4ca7",
	"./speak/medium.txt": "cab9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5aac";